var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "submitFile",
      "centered": true,
      "title": "Do you want to submit the claim file(s)?",
      "hide-footer": true,
      "size": "lg",
      "close-on-backdrop": ""
    },
    on: {
      "hidden": function hidden($event) {
        return _vm.hideModal();
      },
      "shown": _vm.handleModalShown
    }
  }, [_c('div', {
    staticClass: "file-content-wrap"
  }, [_c('div', [_c('label', [_vm._v("Plan Name: ")]), _c('p', [_vm._v(_vm._s(_vm.claimData.plan_overview.plan_name))])]), _vm.claimData.is_LifeOr7kEnabled ? _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("Death Date "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _c('div', {
    staticClass: "date-picker-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.death_date,
      expression: "death_date"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "claim-date",
      "type": "date",
      "max": _vm.maxDate
    },
    domProps: {
      "value": _vm.death_date
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.death_date = $event.target.value;
      }, _vm.onInput]
    }
  })]), _vm.touched && !_vm.$v.death_date.$pending && (!_vm.$v.death_date.$model || !_vm.$v.death_date.$dirty) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" Death Date is required ")]) : _vm._e()]) : _vm._e(), _c('p', {
    staticClass: "mb-3"
  }, [_vm._v(" The file(s) you want to upload: ")]), _c('div', {
    staticClass: "d-flex flex-wrap mb-2"
  }, _vm._l(_vm.files, function (file) {
    return _c('div', {
      key: file.id,
      staticClass: "mb-2 pr-0 mr-2"
    }, [_c('div', {
      staticClass: "mb-2 pl-2 file-name-wrap pb-1"
    }, [_c('a', {
      staticClass: "clr-active",
      attrs: {
        "href": file.filepath,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "pr-3 pb-4"
    }, [_vm._v(_vm._s(file.filename))]), _c('div', {
      staticClass: "download-icon"
    }, [_c('i', {
      staticClass: "fas fa-download ml-2",
      staticStyle: {
        "font-size": "10px",
        "position": "absolute",
        "top": "5px",
        "left": "5px"
      }
    })])])])]);
  }), 0)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('div', {
    staticClass: "cancel-btn mr-3",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('button', {
    on: {
      "click": _vm.hideModal
    }
  }, [_vm._v("Cancel")])]), _c('div', {
    staticClass: "submit-btn upload-submit"
  }, [_c('button', {
    on: {
      "click": _vm.submitHandler
    }
  }, [_vm._v("Submit")])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }